import { AppService } from "app/services/app.service";

import { AppFilter } from "app/models/app-filter.model";

export abstract class AbDistribuidor extends AppService {
  abstract desativarDistribuidor(id: number);
  abstract getAllDistribuidores(filter: AppFilter);
  abstract formatarData(data: any): Date;
  abstract tratarData(data): void;
}